import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { NavigationMenu } from '@components/navigation/NavigationMenu';
import { TopBar } from '@components/navigation/TopBar';

export const AppLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <NavigationMenu
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <TopBar onMenuToggle={() => setSidebarOpen(true)} />
      <main className="mt-16 p-4 md:ml-64 md:mt-20 md:p-8">
        <Outlet />
      </main>
    </div>
  );
};
